const ShowAnswersButton = ({ onClickShowAnswers, showAnswers, className, style }) => {
	return (
		<div
			className={"clickable " + (className || '')}
			style={style}
			onClick={onClickShowAnswers}
		>
			{showAnswers ? 'Hide Answers' : 'Show Answers'}
		</div>
	);
};

export default ShowAnswersButton;
